/** Copyright (c) 2018 T. Rowe Price. All rights reserved. */

import './RMDTable.scss';

import React from 'react';
import TableFooter from './TablePagination';
import {
  currency,
  mapAgreementType,
  accountNumber,
} from '../../../../utils/dashboard-utils';

const TableBody = (props) => {
  if (props) {
    if (props.showYTDColumns) {
      return (
        <tbody>
          {props.retirementPlans.map((plan, index) => [
            <tr className="purpose" key={index}>
              <td className="name">{plan.planName}</td>
              <td className="account"></td>
              <td className="account-balance"></td>
              <td className="year-rmd"></td>

              <td className="distributions-ytd">
                {currency(plan.subTotalDistributionAccountLevel)}
              </td>
              <td className="remaining-year">
                {currency(plan.subTotalRemainingYearAccountLevel)}
              </td>
              <td className="tax-ytd">
                {currency(plan.subTotalTaxWithHoldingsAccountLevel)}
              </td>
            </tr>,
            _planBody(
              plan.agreementTypeContainers,
              plan.planName,
              props.showYTDColumns
            ),
          ])}
          <TableFooter
            pagination={props.pagination}
            handleClick={props.handleClick}
          />
        </tbody>
      );
    }
    return (
      <tbody>
        {props.retirementPlans.map((plan, index) => [
          <tr className="purpose" key={index}>
            <td className="name">{plan.planName}</td>
            <td className="account"></td>
            <td className="account-balance"></td>
            <td className="year-rmd"></td>
          </tr>,
          _planBody(
            plan.agreementTypeContainers,
            plan.planName,
            props.showYTDColumns
          ),
        ])}
        <TableFooter
          pagination={props.pagination}
          handleClick={props.handleClick}
        />
      </tbody>
    );
  }
};

const _planBody = (agreementTypeContainers, planName, showYTDColumns) => {
  return _groupByAgreementType(
    agreementTypeContainers,
    planName,
    showYTDColumns
  );
};

const _groupByAgreementType = (agreementTypes, planName, showYTDColumns) => {
  return agreementTypes.map((agreementType, agreementTypeIndex) => {
    return [
      _groupByAgreementTypeHeader(
        agreementType,
        agreementTypeIndex,
        planName,
        showYTDColumns
      ),
      _groupByAgreementTypeBody(
        agreementType,
        agreementTypeIndex,
        planName,
        showYTDColumns
      ),
    ];
  });
};

const _groupByAgreementTypeHeader = (
  agreementType,
  index,
  planName,
  showYTDColumns
) => {
  if (showYTDColumns) {
    return (
      <tr className="account" key={index}>
        <td className="name">
          {mapAgreementType(agreementType.agreementTypeName)}
        </td>
        <td className="account" />
        <td className="account-balance">
          {currency(agreementType.subTotalAccountBalanceAgreementLevel)}
        </td>
        <td className="year-rmd">
          {currency(agreementType.subTotatRMDTotalAgreementLevel)}
        </td>

        <td className="distributions-ytd">
          {currency(agreementType.subTotalDistributionAgreementLevel)}
        </td>
        {planName === 'IRA' || planName === '403(b)' ? (
          <td className="remaining-year">
            {' '}
            <div className="greyedout"></div>
          </td>
        ) : (
          <td className="remaining-year">
            {currency(agreementType.subTotalRemainingYearAgreementLevel)}
          </td>
        )}
        <td className="tax-ytd">
          {currency(agreementType.subTotalTaxWithHoldingsAgreementLevel)}
        </td>
      </tr>
    );
  }
  return (
    <tr className="account" key={index}>
      <td className="name">
        {mapAgreementType(agreementType.agreementTypeName)}
      </td>
      <td className="account" />
      <td className="account-balance">
        {currency(agreementType.subTotalAccountBalanceAgreementLevel)}
      </td>
      <td className="year-rmd">
        {currency(agreementType.subTotatRMDTotalAgreementLevel)}
      </td>
    </tr>
  );
};

const _groupByAgreementTypeBody = (
  agreementType,
  index,
  planName,
  showYTDColumns
) => {
  if (showYTDColumns) {
    return agreementType.rmdAgreements.map((agreement, agreementIndex) => {
      return (
        <tr className="fund" key={agreementIndex}>
          <td className="name">{agreement.accountNameDisplay}</td>
          <td className="account blocked_data">{accountNumber(agreement)}</td>
          <td className="account-balance">{currency(agreement.balance)}</td>
          <td className="year-rmd">{currency(agreement.rmdamount)}</td>

          <td className="distributions-ytd">
            {currency(agreement.distributionYTD)}
          </td>
          {planName === 'IRA' || planName === '403(b)' ? (
            <td className="remaining-year">
              {' '}
              <div className="greyedout"></div>
            </td>
          ) : (
            <td className="remaining-year">
              {' '}
              {currency(agreement.remainingRMDForYear)}
            </td>
          )}
          <td className="tax-ytd">{currency(agreement.taxWithHoldingsYTD)}</td>
        </tr>
      );
    });
  }
  return agreementType.rmdAgreements.map((agreement, agreementIndex) => {
    return (
      <tr className="fund" key={agreementIndex}>
        <td className="name">{agreement.accountNameDisplay}</td>
        <td className="account blocked_data">{accountNumber(agreement)}</td>
        <td className="account-balance">{currency(agreement.balance)}</td>
        <td className="year-rmd">{currency(agreement.rmdamount)}</td>
      </tr>
    );
  });
};
export default TableBody;
